import jQuery from 'jquery';

jQuery(function($) {
  let $search = $('.search');

  $search.each(function() {
    let $block = $(this);
    let $searchForm = $block.find('.form--search');
    let $showButton = $block.find('.search__open');
    let $closeButton = $block.find('.form__close');
    let $field = $searchForm.find('.form__field');

    $field.on('keydown', function(event) {
      if (event.key === 'Enter') {
        $searchForm.trigger('submit');
      }
    });

    $showButton.on('click', function() {
      $searchForm.removeClass('d-none');
      $field.trigger('focus');
    });

    $closeButton.on('click', function() {
      $searchForm.addClass('d-none');
    });
  });
});
